<template>
    <el-popover
        v-model="visible"
        :width="width"
        :trigger="trigger"
        popper-class="export_button_popover"
    >
        <div class="export_button_inner" v-loading="loading">
            <slot name="current">
                <div class="export_button__item" @click="handleExportCurrent">
                    <as-icon name="xiashuju"></as-icon>
                    <span>导出当前门店报表</span>
                </div>
            </slot>
            <div class="export_button__item" v-if="!hideAllButton" @click="handleExportAll">
                <as-icon name="xiashuju"></as-icon>
                <span>导出所有门店报表</span>
            </div>
            <div class="export_button__item" v-if="!hideAllButton" @click="handleExportSpecified">
                <as-icon name="xiashuju"></as-icon>
                <span>导出指定门店报表</span>
            </div>
        </div>
        <span slot="reference" class="export_button__reference_wrapper">
            <slot>
                <button class="export_button__reference" @click.prevent>
                    <as-icon class="export_button__reference_icon" name="xiashuju"></as-icon>
                    导出
                </button>
            </slot>
        </span>
    </el-popover>
</template>
<script>
import AsIcon from '@/components/icon'
import ExclusiveApi from '@/api/exclusive'
import { ShopSelectModal } from '@/components/shop-dialog-selector'
import Cookie from 'js-cookie'
export default {
    name: 'ExportButtonPopover',
    components: {
        AsIcon
    },
    props: {
        hideAllButton: Boolean,
        shopId: [String, Number],
        queryData: Object,
        serviceName: {
            type: String,
            default: 'SERVICE_ITEM_CLASS_DETAIL'
        },
        width: {
            type: Number,
            default: 150
        },
        trigger: {
            type: String,
            default: 'click'
        },
        placement: {
            type: String,
            default: 'bottom'
        },
        boundariesElement: {
            type: [String, Object],
            default: 'body'
        },
        tenantId: String
    },
    data() {
        return {
            visible: false,
            loading: false,
            listData: [],
            shopAreaData: null,
        }
    },
    methods: {
        handleExportCurrent() {
            const shopId = this.shopId || Cookie.get(`cacheShopId_${Cookie.get('token')}`);
            if (shopId) {
                this.exportData(shopId);
            } else {
                this.$message.error('请先选择门店')
            }
        },
        handleExportSpecified() {
            this.visible = false
            ShopSelectModal.show({
                title: '选择门店',
                multiple: true,
                defaultCheckedKeys: [],
                loadData: (callback) => {
                    this.loadShopAreas(callback)
                },
                beforeConfirm: (nodes) => {
                    if (!nodes || !nodes.length) {
                        this.$message.error('请先选择门店')
                        return false
                    }
                },
                disabledSelectChildFun: (child) => {
                    return Number(child.enabledNewBonusModel) == 1
                }
            }).then(ret => {
                const selectValue = ret && ret.selectValue ? ret.selectValue : []
                const shopIds = selectValue.map(item => item.id).filter(id => id !== undefined && id !== null && id !== '')
                if (!shopIds.length) {
                    this.$message.error('请先选择门店')
                    return
                }
                this.exportData(undefined, shopIds)
            })
        },
        loadShopAreas(callback) {
            if (this.shopAreaData) {
                callback(this.shopAreaData)
                return
            }
            const baseUrl = process.env.NODE_ENV === 'development' ? 'https://test2.meiguanjia.net' : window.location.origin
            const xhr = new XMLHttpRequest()
            xhr.open('POST', `${baseUrl}/shair/superOperationReport!getAreas.action`)
            xhr.withCredentials = true
            xhr.setRequestHeader('request-from', 'MGJ_SHAIR')
            xhr.setRequestHeader('Token', Cookie.get('token') || '')
            xhr.onreadystatechange = () => {
                if (xhr.readyState !== 4) return
                const emptyData = { name: '', id: '', children: [] }
                if (xhr.status < 200 || xhr.status >= 300) {
                    this.$message.error('门店数据读取失败')
                    callback(emptyData)
                    return
                }
                try {
                    const res = JSON.parse(xhr.responseText || '{}')
                    const data = res.content || emptyData
                    if (!Array.isArray(data.children)) {
                        data.children = []
                    }
                    if (res.code !== 0) {
                        this.$message.error(res.message || '门店数据读取失败')
                        callback(emptyData)
                        return
                    }
                    if (!data.children.length) {
                        this.$message.warning('暂无可选门店')
                    } else {
                        this.shopAreaData = data
                    }
                    callback(data)
                } catch (e) {
                    this.$message.error('门店数据读取失败')
                    callback(emptyData)
                }
            }
            xhr.onerror = () => {
                this.$message.error('门店数据读取失败')
                callback({ name: '', id: '', children: [] })
            }
            xhr.send()
        },
        handleExportAll() {
            this.exportData()
        },
        exportData(shopId, shopIds) {
            this.loading = true
            const params = {
                serviceName: this.serviceName,
                shopId: shopId,
                parentShopId: this.tenantId || Cookie.get("realParentShopId"),
                queryBody: this.queryData,
                tenantId: this.tenantId,
            }
            if (shopIds && shopIds.length) {
                params.shopIds = shopIds
            }
            ExclusiveApi.createExportTask(params).then(res => {
                this.$message.success('导出任务已添加')
                this.loading = false
            }).catch(err => {
                this.loading = false
                const errMessage = err.code === 1100002 ? "不允许频繁导出" : err.message
                this.$message.error(errMessage)
            })
        }
    },
    computed: {
        popperOptions() {
            return {
                "boundariesElement": this.boundariesElement
            }
        }
    },
}
</script>
<style lang="scss">
.export_button_popover {
    padding: 8px 0;
    .export_button__item {
        line-height: 1;
        height: 28px;
        padding: 0 12px;
        display: flex;
        align-items: center;
        transition: all .3s;
        color: #5A5E66;
        font-size: 12px;
        cursor: pointer;
        &:hover {
            background-color: #F6F6F6;
            color: #409EFE;
        }
        & .s-iconfont {
            margin-right: 6px;
            font-size: 12px;
        }
    }
}
.export_button__reference_wrapper {
    display: inline-flex;
}
.export_button__reference {
    width: 54px;
    height: 30px;
    background: #2A62FF;
    border-radius: 3px;
    overflow: hidden;
    border: none;
    color: #fff;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
    transition: all .3s;
    &:hover {
        background: rgba(42, 98, 255, .8);
    }
}
.export_button__reference_icon {
    font-size: 12px;
    margin-right: 2px;
}
</style>